import React, { ReactElement } from 'react';
import { TextLabel, Icon, Text, Flex } from '@tonic-ui/react';
import InfoPopover from '../info-popover/info-popover';

type FieldTextLabelProps = {
  name: string;
  htmlFor: string;
  isRequired: boolean;
  infoPopoverContent?: ReactElement;
};

const FieldTextLabel = ({
  name,
  htmlFor,
  isRequired,
  infoPopoverContent,
}: Partial<FieldTextLabelProps>): JSX.Element => {
  return (
    <Flex alignItems="baseline">
      <TextLabel as="label" htmlFor={htmlFor} marginBottom="1x">
        {`${name}:`}
        {isRequired ? (
          <Text as="sup" display="inline">
            <Icon icon="asterisk" color="red:50" />
          </Text>
        ) : null}
      </TextLabel>
      {infoPopoverContent ? <InfoPopover body={infoPopoverContent} /> : null}
    </Flex>
  );
};

FieldTextLabel.displayName = 'FieldTextLabel';

export default FieldTextLabel;
